// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"8a03f924","830":"95c7e75f"}[chunkId] + ".chunk.css";
};